import { CalendarBlank } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const pad = (n) => String(n).padStart(2, "0");
export const TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

// value: { day: Date|null, time: "HH:MM" } in the browser's timezone
export const toISO = ({ day, time }) => { const [h, m] = time.split(":").map(Number); const d = new Date(day); d.setHours(h, m, 0, 0); return d.toISOString(); };
export const fromISO = (iso) => { const d = new Date(iso); return { day: d, time: `${pad(d.getHours())}:${pad(d.getMinutes())}` }; };

export const DayTimePicker = ({ value, onChange, testid }) => (
  <div className="flex items-center gap-2">
    <Popover>
      <PopoverTrigger asChild><Button size="sm" variant="secondary" className="h-8 w-36 justify-start gap-1 text-xs" data-testid={`${testid}-day`}><CalendarBlank />{value.day ? value.day.toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short" }) : "Pick a day"}</Button></PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-[#121212] border-border" align="end"><Calendar mode="single" selected={value.day} onSelect={(d) => onChange({ ...value, day: d })} disabled={(d) => d < new Date(new Date().toDateString())} weekStartsOn={1} /></PopoverContent>
    </Popover>
    <Input type="time" step={1800} data-testid={`${testid}-time`} value={value.time} onChange={(e) => onChange({ ...value, time: e.target.value })} className="bg-black w-28 h-8 text-xs" />
    {TZ !== "Australia/Sydney" && <span className="text-[10px] text-zinc-500 font-mono" data-testid={`${testid}-tz`}>{TZ}</span>}
  </div>
);
